
import mapboxgl from 'mapbox-gl';

export const addVectorLayers = (map: mapboxgl.Map) => {
  try {
    console.log('Starting to add vector layers to map');
    
    // Check if the source exists and remove it first to avoid conflicts
    if (map.getSource('states-source')) {
      console.log('Removing existing states-source');
      
      // First remove any layers using this source
      if (map.getLayer('states-church-presence')) {
        console.log('Removing existing states-church-presence layer');
        map.removeLayer('states-church-presence');
      }
      if (map.getLayer('special-regions-border')) {
        console.log('Removing existing special-regions-border layer');
        map.removeLayer('special-regions-border');
      }
      
      map.removeSource('states-source');
    }
    
    // Add new source for states
    console.log('Adding states-source');
    map.addSource('states-source', {
      type: 'vector',
      url: 'mapbox://mapbox.boundaries-adm1-v3'
    });
    
    console.log('Adding states-church-presence layer');
    // Add fill layer with the specified colors
    map.addLayer({
      id: 'states-church-presence',
      type: 'fill',
      source: 'states-source',
      'source-layer': 'boundaries_admin_1',
      filter: [
        'all',
        ['==', ['get', 'iso_3166_1'], 'MX']
      ],
      paint: {
        'fill-color': [
          'match',
          // Get the name of the state
          ['get', 'name_en'],

          // --- GOOD (blue) ---
          [
            "Aguascalientes","Baja California","Baja California Sur","Campeche",
            "Chihuahua","Coahuila","Colima","Durango","Guanajuato","Jalisco",
            "Mexico","Mexico City","Michoacán","Morelos","Nayarit","Nuevo León",
            "Puebla","Querétaro","Quintana Roo","San Luis Potosí","Sinaloa",
            "Sonora","Tabasco","Tamaulipas","Tlaxcala","Veracruz","Yucatán","Zacatecas"
          ],
          "#0000FF",

          // --- LOW (pink) ---
          ["Chiapas","Guerrero","Oaxaca"],
          "#FFC0CB",

          // --- UNREACHED (reddish) ---
          ["Hidalgo"],
          "#FF4C4C",

          // fallback
          "#CCCCCC"
        ],
        'fill-opacity': 0.6
      }
    });

    console.log('Adding special-regions-border layer');
    // Add border layer for special regions
    map.addLayer({
      id: 'special-regions-border',
      type: 'line',
      source: 'states-source',
      'source-layer': 'boundaries_admin_1',
      filter: [
        'all',
        ['==', ['get', 'iso_3166_1'], 'MX'],
        ['any',
          ['in', ['get', 'name_en'], ['literal', ['Chiapas', 'Guerrero', 'Oaxaca', 'Hidalgo']]]
        ]
      ],
      paint: {
        'line-color': [
          'match',
          ['get', 'name_en'],
          ['Chiapas', 'Guerrero', 'Oaxaca'], '#9333ea', // Purple for Low presence
          ['Hidalgo'], '#f97316', // Orange for Unreached
          '#ffffff'  // Default white
        ],
        'line-width': 3,
        'line-opacity': 0.8
      }
    });
    
    console.log('Successfully added vector layers');
  } catch (error) {
    console.error('Error adding vector layers:', error);
  }
};

// Helper function to check if the styles are loaded
export const waitForStyleLoad = (map: mapboxgl.Map): Promise<void> => {
  return new Promise((resolve) => {
    if (map.isStyleLoaded()) {
      console.log('Map style already loaded');
      resolve();
    } else {
      console.log('Waiting for map style to load...');
      map.once('style.load', () => {
        console.log('Map style now loaded');
        resolve();
      });
    }
  });
};

// Helper function to check if Mapbox has access token set
export const verifyMapboxSetup = (): boolean => {
  const hasToken = !!mapboxgl.accessToken;
  console.log('Mapbox access token is', hasToken ? 'set' : 'NOT set');
  return hasToken;
};
